import { Action } from 'redux'
import { isType } from 'ts-action'
import { IRostersReducer, IRoster } from '@network/models/roster.model'
import { deleteFromArray, reorderArray } from 'helpers/helperFuncs'
import {
  DeleteRoster,
  GetRosters,
  ReorderRosters,
  RostersFetching,
} from './actions'

const initialState: IRostersReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const rostersReducer = (
  state = initialState,
  action: Action,
): IRostersReducer => {
  if (isType(action, GetRosters)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, DeleteRoster)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IRoster>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, RostersFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }

  if (isType(action, ReorderRosters)) {
    const {
      payload: { oldIndex, newIndex },
    } = action
    const { data } = state
    const reorderedData = reorderArray<IRoster>(data, oldIndex, newIndex)

    return {
      ...state,
      data: reorderedData,
    }
  }

  return state
}
